import React, { useState } from 'react'
import { Row, Col, Table, Button, Form, FormControl } from 'react-bootstrap'
import { FetchCreateB2COrderTransaction } from '../../fetcher'
import { ModalComponent } from '../presentational-components/ModalComponent'
import AlertMessage from '../presentational-components/AlertMessage'
import NewSale from './NewSale'
import { Redirect } from 'react-router-dom'

const PayProcessB2COrder = ({ paymentList, transactions, contactDetails, setContactDetails, setContactDetailsReady, date, handleClose, handleRedirect, reload, openAlert }) => {
    const [payment, setPayment] = useState(null)

    //const [showAlertMessage, setShowAlert] = useState(false)

    //const openAlert = () => {
    //    setShowAlert(true)
    //}
    //const closeAlert = () => {
    //    setShowAlert(false)
    //}

    //const redirect = () => {
    //    return (
    //        <Redirect to="/authentication" />
    //    )
    //}
    //const handleShowTransactions = () => {
    //    return (
    //        //redirect()
    //    )
    //}

    const handleSubmit = (e) => {
        e.preventDefault()

        const B2COrderTransactionToCreate = []
        console.log("B2CToCreate")
        transactions.forEach(x => B2COrderTransactionToCreate.push({ DesignerSysId: x.designer.DesignerSysId, ArticleTypeSysId: x.articleType.ArticleTypeSysId, SizeCategory: x.sizeCategory.SizeCategorySysId, SizeValue: x.size.Size, Amount: x.number, Remarks: x.remarks, PriceAtTimeOfSale: parseFloat(x.priceAtTimeOfOrdering), PrepaymentAtTimeOfOrdering: parseFloat(x.prepayment) }))
        const shippingToCustomer = Object.keys(contactDetails).includes("shippingOption")

        console.log("B2CCreate handleSubmit Contact: ", contactDetails)

        const BoutiqueSaleTransactionsListToCreate = {
            Payment: payment,
            SerializedTransactionData: JSON.stringify(B2COrderTransactionToCreate),
            DateOfSale: date.toISOString(),
            //Email: contactDetails.Contact.Email,
            //PhoneNumber: contactDetails.Contact.Phone,
            //SalutationForContact: contactDetails.Contact.Salutation,
            //NameForContact: contactDetails.Contact.Name,
            //SurnameForContact: contactDetails.Contact.Surname,
            ShippingOption: contactDetails.ShippingOption,
            //Salutation: contactDetails.Salutation,
            //Name: contactDetails.Name,
            //Surname: contactDetails.Surname,
            //Street: contactDetails.Street,
            //HouseNumber: contactDetails.HouseNumber,
            //AdditionalLines: contactDetails.AdditionalLines,
            //PostalCode: contactDetails.PostalCode,
            //City: contactDetails.City,
            //Country: contactDetails.Country,
            ContactSysId: contactDetails.Contact.ContactSysId,
            AddressSysId: contactDetails.AddressSysId,
        }
        console.log("B2CToCreate ", B2COrderTransactionToCreate, BoutiqueSaleTransactionsListToCreate)

        FetchCreateB2COrderTransaction(BoutiqueSaleTransactionsListToCreate, reload, openAlert)


        handleRedirect()
        handleClose()
    }

    return (
        <div>
            <Form onSubmit={handleSubmit} id='boutique-payprocess-form'>
                <p>Bitte wählen Sie eine Zahlungsmethode und bestätigen Sie anschließend die Buchung.</p>

                <FormControl as="select" onChange={(e) => setPayment(e.target.value)}>
                    <option defaultValue selected disabled>Zahlungsmittel</option>
                    {paymentList.map(payment =>
                        <option>{payment}</option>
                    )}
                </FormControl>
            </Form>

            {/*<AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />*/}
        </div>
    )
}

export default PayProcessB2COrder